import React, { useState, useEffect } from "react";
import Axios from "axios";
import { submitComment } from "../../services";

const CommentsForm = ({ slug }) => {
	const [error, setError] = useState(false);
	const [localStorage, setLocalStorage] = useState(null);
	const [showSuccessMessage, setShowSuccessMessage] = useState(false);
	const [formData, setFormData] = useState({
		name: null,
		email: null,
		comment: null,
		storeData: false,
	});

	// const [cname, setCname] = useState("");
	// const [ccomment, setCcomment] = useState("");
	// const [cemail, setCemail] = useState("");

	useEffect(() => {
		setLocalStorage(window.localStorage);
		const initalFormData = {
			name: window.localStorage.getItem("name"),
			email: window.localStorage.getItem("email"),
			storeData:
				window.localStorage.getItem("name") ||
				window.localStorage.getItem("email"),
		};
		setFormData(initalFormData);
	}, []);

	const onInputChange = (e) => {
		const { target } = e;
		if (target.type === "checkbox") {
			setFormData((prevState) => ({
				...prevState,
				[target.name]: target.checked,
			}));
		} else {
			setFormData((prevState) => ({
				...prevState,
				[target.name]: target.value,
			}));
		}
	};

	const handlePostSubmission = async () => {
		setError(false);
		const { name, email, comment, storeData } = formData;
		if (!name || !email || !comment) {
			setError(true);
			return;
		}
		const commentObj = {
			name,
			email,
			comment,
			slug,
		};

		if (storeData) {
			localStorage.setItem("name", name);
			localStorage.setItem("email", email);
		} else {
			localStorage.removeItem("name");
			localStorage.removeItem("email");
		}

		const res = await submitComment(commentObj);

		if (res.createComment) {
			if (!storeData) {
				formData.name = "";
				formData.email = "";
			}
			formData.comment = "";
			setFormData((prevState) => ({
				...prevState,
				...formData,
			}));
			setShowSuccessMessage(true);
			setTimeout(() => {
				setShowSuccessMessage(false);
			}, 3000);
		}
	};

	return (
		<div className="bg-white shadow-lg rounded-lg p-8 pb-12 mb-8">
			<h3 className="text-xl mb-8 font-semibold  border-solid border-t-0 border-l-0 border-r-0 border-b-2 pb-4">
				Leave a Reply
			</h3>
			<div className="grid grid-cols-1 gap-4 mb-4">
				{/* increase placeholder size and left align */}
				<textarea
					value={formData.comment}
					onChange={onInputChange}
					className="resize-none p-4 border-0 outline-none w-full rounded-lg h-40 font-montserrat placeholder-gray-700 placeholder:text-left text-gray-700 focus:ring-2 focus:ring-gray-200 bg-gray-100"
					name="comment"
					placeholder="Comment"
				/>
			</div>
			<div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
				<input
					type="text"
					value={formData.name}
					onChange={onInputChange}
					className="py-2 px-4 border-0 outline-none w-full rounded-lg bg-gray-100 font-montserrat placeholder-gray-700 placeholder:text-left text-gray-700 focus:ring-2 focus:ring-gray-200 "
					placeholder="Name"
					name="name"
				/>
				<input
					type="email"
					value={formData.email}
					onChange={onInputChange}
					className="py-2 px-4 border-0 outline-none w-full rounded-lg bg-gray-100 font-montserrat placeholder-gray-700 placeholder:text-left font-Regular text-gray-700 focus:ring-2 focus:ring-gray-200 "
					placeholder="Email"
					name="email"
				/>
			</div>
			<div className="grid grid-cols-1 gap-4 mb-4">
				<div>
					<input
						checked={formData.storeData}
						onChange={onInputChange}
						type="checkbox"
						id="storeData"
						name="storeData"
						value="true"
					/>
					<label className="text-gray-500 cursor-pointer" htmlFor="storeData">
						{" "}
						Save my name, email in this browser for the next time I comment.
					</label>
				</div>
			</div>
			{error && (
				<p className="text-xs text-red-500">All fields are mandatory</p>
			)}
			<div className="mt-8">
				<button
					type="button"
					onClick={handlePostSubmission}
					className="transition border-0 duration-500 ease hover:bg-nishblue-700 inline-block bg-nishyellow-400 text-lg font-medium rounded-full text-white px-8 py-3 cursor-pointer"
				>
					Post Comment
				</button>
				{showSuccessMessage && (
					<span className="text-xl float-right font-semibold mt-3 text-green-500">
						Comment submitted for review
					</span>
				)}
			</div>
		</div>
	);
};

export default CommentsForm;
